/** 论坛默认头像 URL（三端统一） */
export const FORUM_DEFAULT_AVATAR =
  'https://assets.hzwxbz2.cn/box/iOS/img/default-avatar.png'
